import { render, staticRenderFns } from "./RemediatedIddPlusCounterVueContainer.vue?vue&type=template&id=8830c160&scoped=true"
import script from "./RemediatedIddPlusCounterVueContainer.vue?vue&type=script&lang=js"
export * from "./RemediatedIddPlusCounterVueContainer.vue?vue&type=script&lang=js"
import style0 from "./RemediatedIddPlusCounterVueContainer.vue?vue&type=style&index=0&id=8830c160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8830c160",
  null
  
)

export default component.exports